import {
  ConfigurationDto,
  SearchConfigurationResultDto,
  SearchConfigurationsWithSpecsUsingGETQueryParams,
} from 'lib_api/lib/api/gen';

import {
  FetchDataResult,
  TablePagination,
  TableSort,
} from 'components/WrappedComponents/Table/types';
import { useApi } from 'hooks/ApiStoreContext';

import {
  ConfigurationSortOptions,
  DashboardConfigurationFilter,
} from './types';

export function useFetchConfigurationQuery(
  filter: Partial<DashboardConfigurationFilter>,
  sort: TableSort<ConfigurationSortOptions>,
  pagination: TablePagination,
): [
  () => Promise<SearchConfigurationResultDto>,
  (result: SearchConfigurationResultDto) => FetchDataResult<ConfigurationDto>,
] {
  const controllerApi = useApi().AdminFonctionnelControllerApi;

  const fetchData = (): Promise<SearchConfigurationResultDto> => {
    const request: SearchConfigurationsWithSpecsUsingGETQueryParams = {
      page: pagination?.page - 1,
      pageSize: pagination?.pageSize,
      sortByMicroServiceName: sort?.SERVICE,
      fullNameOrDescription: filter.search,
      microServiceName: filter.microServiceName,
      value: filter.value,
      hasError: filter.hasError,
    };

    return controllerApi.searchConfigurationsWithSpecsUsingGET(request);
  };

  const convertToFetchData = (
    searchResult: SearchConfigurationResultDto,
  ): FetchDataResult<ConfigurationDto> => {
    return {
      data: searchResult.configurations,
      total: searchResult.total,
    };
  };

  return [fetchData, convertToFetchData];
}
